import { render } from "./viewUser.html?vue&type=template&id=61c7a8a8&scoped=true&ts=true&external"
import script from "./ViewUser.vue?vue&type=script&lang=ts"
export * from "./ViewUser.vue?vue&type=script&lang=ts"

import "./ViewUser.vue?vue&type=style&index=0&id=61c7a8a8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61c7a8a8"]])

export default __exports__